/**
 * @generated SignedSource<<c679f3b8ecb65ea22a49ae65a96ac9d8>>
 * @relayHash 503ecc2f18e599f750a67b60d4f738e8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5b4f8741ea75ec280458c1606e0745c461c16b1c632b423be98bb54aa16d465b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { GlobalBrandingQuery } from './GlobalBrandingQuery.graphql';

const node: PreloadableConcreteRequest<GlobalBrandingQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "5b4f8741ea75ec280458c1606e0745c461c16b1c632b423be98bb54aa16d465b",
    "metadata": {},
    "name": "GlobalBrandingQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
